export class PropuestaOperacion {
    id_Empresa_Factor: string = '';
    idPropuestaOperacion?: number = 0;
    idProspecto?: number = null;
    idProveedor: string = '';
    Num_Doc_Identificacion_Prov: string = '';
    NombreProveedor?: string = '';
    Scoring_Prov: string = '';
    idAdquirente: string = '';
    Num_Doc_Identificacion_Adq?: string = '';
    NombreAdquirente?: string = '';
    Scoring_Adq: string = '';
    Ranking_Adq: string = '';
    Tipo_Servicio: string = '0';
    Tipo_Servicio_Dsc: string = '';
    Tipo_Documento: string = '';
    Moneda: number = 0;
    Moneda_Dsc?: string = '';
    Estado: string = 'P';
    Alta_Fecha:string = '';
    Alta_Usuario_Comercial: string = '';
    Alta_Usuario_Riesgo: string = '';
    Nombre_Usuario_Comercial: string = '';
    Fecha_Evaluacion: string = '';
    Observaciones_Propuesta: string = '';

    LineaAdmitida?: number; // DATA DE ADQUIRENTE
    LineaUtilizada?: number; // DATA DE ADQUIRENTE
    LineaDisponible?: number; // DATA DE ADQUIRENTE
}
